// Components==============
import { faArrowLeft, faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Shade from 'components/UI/Shade/Shade';
import { useMediaQ } from 'hooks/useMediaQ';
import React, { useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { GlobalSideNavContext } from 'utilities/GlobalContext/GloabalSideNav';
import { LayoutContext } from '../Layout';
import MenuItems from './components/MenuItems/MenuItems';
import './SideNav.module.scss';
// =========================

export default function SideNav() {
  const { sideNavIsOpen, setSideNavIsOpen } = useContext(GlobalSideNavContext);
  const { hamburgerIsOpen, setHamburgerIsOpen } = useContext(LayoutContext);

  const query = useMediaQ('min', 1024);

  const width = sideNavIsOpen ? 215 : 80;
  const x = query ? 0 : hamburgerIsOpen ? 0 : -215;

  useEffect(() => {
    if (hamburgerIsOpen) setSideNavIsOpen(true);
  }, [hamburgerIsOpen]);

  return (
    <>
      <div
        style={{ width, transform: `translateX(${x}px)` }}
        styleName="wrapper"
      >
        {hamburgerIsOpen && !query && (
          <>
            <div styleName="close" onClick={() => setHamburgerIsOpen(false)}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </div>
          </>
        )}
        <div styleName="top">
          <NavLink to="/">
            <img src="/images/Groow-logo.svg" alt="groow-logo" />
          </NavLink>
        </div>
        <MenuItems />
        <div styleName="bottom">
          <button
            type="button"
            onClick={() => setSideNavIsOpen((prev) => !prev)}
          >
            {sideNavIsOpen ? (
              <FontAwesomeIcon icon={faArrowLeft} />
            ) : (
              <FontAwesomeIcon icon={faBars} />
            )}
          </button>
        </div>
      </div>
      {hamburgerIsOpen && !query && (
        <Shade onClick={() => setHamburgerIsOpen(false)} />
      )}
    </>
  );
}
